var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.items),function(row,index){return _c('tr',{key:index,staticClass:"text-xs-center"},[_c('td',[_vm._v("\n      "+_vm._s(row.label)+"\n    ")]),_vm._v(" "),_c('td',[_vm._v("\n      "+_vm._s(row.total)+"\n    ")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9d53a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/DueDateList.vue
// module id = null
// module chunks = 